import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { useShift } from '../-components/use-shift';
import { ShiftRoster } from './-components/shift-roster';
import { Skeleton } from '~/components/ui/skeleton';

export const Route = createFileRoute('/_dashboard/settings/shifts')({
  component: SettingsShiftsRoute,
});

function SettingsShiftsRoute() {
  const { shiftsEnabled } = useShift();

  /** Reachable by URL even with the sidebar link gone. */
  if (!shiftsEnabled) {
    return null;
  }

  return (
    <Suspense fallback={<Skeleton className="h-64 w-full rounded-lg" />}>
      <ShiftRoster />
    </Suspense>
  );
}
